var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6731 19.1286C5.89185 19.1286 6.1106 18.9043 6.1106 18.6799V9.70555C6.1106 9.48119 5.89185 9.25684 5.6731 9.25684C5.45435 9.25684 5.2356 9.48119 5.2356 9.70555V18.6799C5.2356 18.9043 5.45435 19.1286 5.6731 19.1286Z",
    fill: "#ED6565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1731 19.1286C9.39185 19.1286 9.6106 18.9043 9.6106 18.6799V9.70555C9.6106 9.48119 9.39185 9.25684 9.1731 9.25684C8.95435 9.25684 8.7356 9.48119 8.7356 9.70555V18.6799C8.7356 18.9043 8.95435 19.1286 9.1731 19.1286Z",
    fill: "#ED6565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6731 19.1286C12.8918 19.1286 13.1106 18.9043 13.1106 18.6799V9.70555C13.1106 9.48119 12.8918 9.25684 12.6731 9.25684C12.4543 9.25684 12.2356 9.48119 12.2356 9.70555V18.6799C12.2356 18.9043 12.4543 19.1286 12.6731 19.1286Z",
    fill: "#ED6565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9231 22.2694H14.4231C15.6481 22.2694 16.6106 21.2822 16.6106 20.0258V7.01301C17.3543 7.01301 17.9231 6.3848 17.9231 5.66685V4.3207C17.9231 3.60275 17.3543 2.97455 16.6106 2.97455H12.2356V1.17967C12.2356 0.910444 12.0168 0.730957 11.7981 0.730957H6.5481C6.32935 0.730957 6.1106 0.910444 6.1106 1.17967V2.97455H1.7356C1.0356 2.97455 0.423096 3.60275 0.423096 4.3207V5.66685C0.423096 6.3848 1.0356 7.01301 1.7356 7.01301V20.0258C1.7356 21.2822 2.6981 22.2694 3.9231 22.2694ZM6.9856 1.62839H11.3606V2.97455H6.9856V1.62839ZM1.2981 5.66685V4.3207C1.2981 4.05147 1.4731 3.87198 1.7356 3.87198H6.5481H11.7981H16.6106C16.8293 3.87198 17.0481 4.05147 17.0481 4.3207V5.66685C17.0481 5.89121 16.8293 6.11557 16.6106 6.11557H16.1731H2.1731H1.7356C1.4731 6.11557 1.2981 5.89121 1.2981 5.66685ZM15.7356 7.01301V20.0258C15.7356 20.7886 15.1668 21.372 14.4231 21.372H3.9231C3.2231 21.372 2.6106 20.7886 2.6106 20.0258V7.01301H15.7356Z",
    fill: "#ED6565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.dad68696c3d85aa2ce2ec228dca59b30.svg";
export { ForwardRef as ReactComponent };